import { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { useIntl } from "react-intl";
import AddIcon from "@mui/icons-material/Add";
import { DimensionFormField } from "./BusinessRuleDimensionField";
import BusinessRuleResponsiveModal from "../BusinessRuleResponsiveModal";

export interface DimensionValue {
  id: number;
  label?: string;
  name?: string;
  hebergement_nom_court?: string;
}

export interface Dimension {
  id: number;
  label: string;
}

export type DimensionSelected = {
  dimension: Dimension;
  dimensionValue: DimensionValue[];
};

/**
 * BusinessRulePerimeterAdd component.
 * Offer Perimeter addition.
 */
export const BusinessRulePerimeterAdd = ({
  moduleSlug,
  onSubmit,
}: {
  onSubmit: (params: DimensionSelected) => void;
  moduleSlug: string;
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [dimension, setDimension] = useState<Dimension | null>(null);
  const [haveBeenSubmit, setHaveBeenSubmit] = useState<boolean | null>(null);
  const [dimensionValue, setDimensionValue] = useState<DimensionValue[] | null>(
    null
  );

  /**
   * On submit, close modal and call onSubmit function.
   */
  useEffect(() => {
    if (haveBeenSubmit) {
      if (dimension && dimensionValue) {
        onSubmit({ dimensionValue, dimension });
        setDimension(null);
        setDimensionValue(null);
      }
      setOpen(false);
      setHaveBeenSubmit(false);
    }
  }, [haveBeenSubmit, dimensionValue, dimension, onSubmit]);

  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => setOpen(true)}
        size="medium"
        sx={{ marginTop: 1 }}
      >
        <AddIcon />
      </IconButton>
      <BusinessRuleResponsiveModal
        disabled={!dimension || !dimensionValue || dimensionValue.length === 0}
        onClose={() => setOpen(false)}
        onSubmit={() => setHaveBeenSubmit(true)}
        open={open}
        title={intl.formatMessage({ id: "BUSINESS_RULE_PERIMETER_ADD" })}
      >
        <DimensionFormField
          moduleSlug={moduleSlug}
          onChangeDimension={setDimension}
          onChangeDimensionValues={setDimensionValue}
        />
      </BusinessRuleResponsiveModal>
    </>
  );
};
